/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GAATTC → GAATTC (the EcoRI site, no ambiguity).`)
};

const es_iupac_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GAATTC → GAATTC (el sitio EcoRI, sin ambigüedad).`)
};

const de_iupac_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GAATTC → GAATTC (die EcoRI-Schnittstelle, keine Mehrdeutigkeit).`)
};

const nl_iupac_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GAATTC → GAATTC (de EcoRI-site, geen ambiguïteit).`)
};

const fr_iupac_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GAATTC → GAATTC (le site EcoRI, sans ambiguïté).`)
};

const it_iupac_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GAATTC → GAATTC (il sito EcoRI, nessuna ambiguità).`)
};

const pt_br2_iupac_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GAATTC → GAATTC (o sítio EcoRI, sem ambiguidade).`)
};

const pt_iupac_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GAATTC → GAATTC (o local de restrição EcoRI, sem ambiguidade).`)
};

const ja_iupac_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GAATTC → GAATTC（EcoRIサイト、あいまいさなし）。`)
};

const zh_iupac_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GAATTC → GAATTC（EcoRI 位点，无简并性）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_ex2", locale)
	if (locale === "en") return en_iupac_ex2(inputs)
	if (locale === "es") return es_iupac_ex2(inputs)
	if (locale === "de") return de_iupac_ex2(inputs)
	if (locale === "nl") return nl_iupac_ex2(inputs)
	if (locale === "fr") return fr_iupac_ex2(inputs)
	if (locale === "it") return it_iupac_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_ex2(inputs)
	if (locale === "pt") return pt_iupac_ex2(inputs)
	if (locale === "ja") return ja_iupac_ex2(inputs)
	return zh_iupac_ex2(inputs)
};